import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map, tap, filter } from 'rxjs/operators';

import { ExternalLinkService, ExternalLinkStatus } from '../services';

@Injectable({
    providedIn: 'root'
})
export class TokenGuard  {
    constructor(private readonly router: Router, private readonly externalLinkService: ExternalLinkService) { }

    canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
        return this.externalLinkService.status.pipe(
            filter(tokenStatus => tokenStatus !== ExternalLinkStatus.VALIDATION),
            tap(status => {
                if (status === ExternalLinkStatus.NOT_PROVIDED) {
                    this.router.navigate(['/'], { replaceUrl: true });
                }
            }),
            map(status => status === ExternalLinkStatus.PROVIDED)
        );
    }
}

